import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';

import View from './View';
import Data from './Data';

const Edit = (props: any) => {
  const { selected } = props;

  return (
    <>
      <View {...props} isEditMode />

      <SidebarPortal selected={selected}>
        <Data {...props} />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(Edit);
